const table113 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "row_number",
        name: "行番号",
        editable: false
    },
    {
        key: "year_begin",
        name: "事業年度等(期首)",
        editable: true,
        type: "date"
    },
    {
        key: "year_end",
        name: "事業年度等(期末)",
        editable: true,
        type: "date"
    },
    {
        key: "corporate_tax_receivable_outstanding",
        name: "(未収還付分)期首現在未納税額",
        editable: true
    },
    {
        key: "refundable_tax_amount_occurred_current_period",
        name: "(還付分)当期発生税額",
        editable: true
    },
    {
        key: "refundable_tax_payment_disposing_reserve",
        name: "(還付分)充当金取崩納付",
        editable: false
    },
    {
        key: "refundable_tax_payment_from_suspense_account",
        name: "(還付分)仮払経理納付",
        editable: true
    },
    {
        key: "refundable_tax_payment_processed_loss",
        name: "(還付分)損金経理納付",
        editable: true
    },
    {
        key: "current_outstanding_amount",
        name: "期首現在未納税額",
        editable: true
    },
    {
        key: "tax_amount_occurred_current_period",
        name: "当期発生税額",
        editable: true
    },
    {
        key: "tax_payment_disposing_reserve",
        name: "充当金取崩納付",
        editable: false
    },
    {
        key: "tax_payment_from_suspense_account",
        name: "仮払経理納付",
        editable: true
    },
    {
        key: "tax_payment_processed_loss",
        name: "損金経理納付",
        editable: true
    }
];

export { table113 };
